import { Component, Input, OnInit } from "@angular/core";




@Component({
  selector: "app-score-card",
  templateUrl: "./score-card.component.html",
  styleUrls: ["./score-card.component.css"]
})
export class ScoreCardComponent implements OnInit {
  @Input() cardValue;
  @Input() cardName: string;
  @Input() cardTooltip: string;
  @Input() cardIcon: string;
  Icon = 'assets/images/W-SPARKING-CHANGE.png';
  constructor() { }

  ngOnInit() {
  }

  getTooltip() {
    return this.cardName !== "Total Suppliers"? this.cardTooltip: '';
  }


}
